const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/community/$id.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_app/community/$id.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { buildCanonicalAlternates } from "@/i18n/alternates";
import { buildPagePreviewMetaTags } from "@/lib/buildPagePreviewMetaTags";
import { ROLLOUT_NOINDEX_ROBOTS } from "@/lib/seo-meta";
import { getRootLoaderData } from "@/types/intl";
export const Route = createFileRoute("/_app/community/$id")({
  loader: lazyFn($$splitLoaderImporter, 'loader'),
  head: async ({
    match,
    params
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const tMeta = createTranslator({
      locale,
      messages,
      namespace: "globals.metadata"
    });
    const alts = buildCanonicalAlternates(`/community/${params.id}`);
    return {
      meta: await buildPagePreviewMetaTags({
        title: tMeta("community"),
        description: tMeta("communityDescription"),
        canonicalUrl: alts.canonical
      }, {
        robots: ROLLOUT_NOINDEX_ROBOTS,
        openGraph: {
          type: "article"
        }
      }, {
        locale
      }),
      links: [{
        rel: "canonical",
        href: alts.canonical
      }]
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});